<div class="row">
  <ng-container>
    <div class="col-md-4" *ngFor="let setting of Data.profit_sharing; let i = index">
      <div class="card mb-2">
        <div class="card-body">
          <div class="d-flex">
            <img
              [src]="setting.game_logo | imgHost"
              [alt]="setting.game_code"
              style="width: 116px; padding: 5px"
              class="img-logo-shadow bg-primary rounded"
            />
            <div class="ps-3 pt-2">
              {{ "STATUS" | translate }} <br />
              <div class="form-check form-check-inline text-danger">
                <input
                  id="game_disable_{{ i }}"
                  type="radio"
                  class="form-check-input"
                  name="game_disable_{{ i }}"
                  [value]="false"
                  [(ngModel)]="setting.game_enable"
                />
                <label for="game_disable_{{ i }}" class="form-check-label">
                  {{ "DISABLE" | translate }}
                </label>
              </div>
              <div class="form-check form-check-inline text-primary">
                <input
                  id="game_enable_{{ i }}"
                  type="radio"
                  class="form-check-input"
                  name="game_enable_{{ i }}"
                  [value]="true"
                  [(ngModel)]="setting.game_enable"
                />
                <label for="game_enable_{{ i }}" class="form-check-label">
                  {{ "ENABLE" | translate }}
                </label>
              </div>
            </div>
          </div>
          <small class="d-block opacity-50 mb-2">{{ setting.game_code }}</small>
          <div class="row">
            <div class="col-12">
              <div class="card border-0">
                <div class="card-body bg-primary text-end">
                  <small class="d-block opacity-50">
                    {{ "RECEIVED" | translate }} = {{ setting.percent_parent }}%
                  </small>
                  <div class="d-flex">
                    <div class="input-group me-1">
                      <span class="input-group-text">
                        {{ "PLACE_TO_FIGHT" | translate }}
                      </span>
                      <input
                        type="number"
                        class="form-control text-end"
                        [(ngModel)]="setting.percent_own"
                        (ngModelChange)="onChangePercent(setting.game_code)"
                        (keyup)="onChangePercent(setting.game_code)"
                        (keydown)="onChangePercent(setting.game_code)"
                        (keypress)="onChangePercent(setting.game_code)"
                        [max]="setting.percent_given"
                        step="0.5"
                        min="0"
                      />
                      <span class="input-group-text">%</span>
                    </div>
                    <div class="input-group">
                      <span class="input-group-text">
                        {{ "RELEASE" | translate }}
                      </span>
                      <input
                        type="number"
                        class="form-control text-end"
                        [value]="setting.percent_given"
                        readonly
                      />
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-12">
              {{ "LIMITED_PLAY" | translate : { game: "HDP/OU/OE" } }}
              <div class="d-flex">
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.min_HUP_OU_OE"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    (
                    {{
                      "THE_BET_SHOULD_NOT_BE_LESS_THAN_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.sport_betlimit?.max?.min_HUP_OU_OE || 0,
                              currency: "THB"
                            }
                    }}
                    )
                  </div>
                </div>
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.max_HUP_OU_OE"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    (
                    {{
                      "BETS_SHOULD_NOT_EXCEED_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.sport_betlimit?.max?.max_HUP_OU_OE || 0,
                              currency: "THB"
                            }
                    }}
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              {{ "LIMITED_PLAY" | translate : { game: "1X2/DC" } }}
              <div class="d-flex">
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.min_DC1X2"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    ({{
                      "THE_BET_SHOULD_NOT_BE_LESS_THAN_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.sport_betlimit?.max?.min_DC1X2 || 0,
                              currency: "THB"
                            }
                    }}
                    )
                  </div>
                </div>
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.max_DC1X2"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    ({{
                      "BET_SHOULD_NOT_EXCEED_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.sport_betlimit?.max?.max_DC1X2 || 0,
                              currency: "THB"
                            }
                    }}
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              {{ "LIMITED_PLAY" | translate : { game: "ETC." } }}
              <div class="d-flex">
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.min_any"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    (
                    {{
                      "BETS_SHOULD_NOT_BE_LESS_THAN_AMOUNT_CURRENCY"
                        | translate
                          : { amount: setting?.sport_betlimit?.max?.min_any || 0, currency: "THB" }
                    }}
                    )
                  </div>
                </div>
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.max_any"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    (
                    {{
                      "BET_SHOULD_NOT_EXCEED_AMOUNT_CURRENCY"
                        | translate
                          : { amount: setting?.sport_betlimit?.max?.max_any || 0, currency: "THB" }
                    }}
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              {{ "MAXIMUM_PER_TRANSACTION_OR_GAME" | translate }}
              <div class="d-flex">
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.min_per_macth"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    (
                    {{
                      "BETS_SHOULD_NOT_BE_LESS_THAN_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.sport_betlimit?.max?.min_per_macth || 0,
                              currency: "THB"
                            }
                    }}
                    )
                  </div>
                </div>
                <div class="w-50">
                  <div class="input-group">
                    <span class="input-group-text"> {{ "LOWEST" | translate }} </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting?.sport_betlimit?.current.max_per_macth"
                      [min]="0"
                    />
                    <span class="input-group-text"> THB </span>
                  </div>
                  <div class="text-end small opacity-50 mt-1">
                    (
                    {{
                      "BET_SHOULD_NOT_EXCEED_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.sport_betlimit?.max?.max_per_macth || 0,
                              currency: "THB"
                            }
                    }}
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
